import { Button } from "react-native-paper";
import Box from "../Box";
import { InsightCallout } from "./InsightCallout";
import { SPACING } from "./constants";

type CardActionProps = {
	insightText?: string;
	animateInsight?: boolean;
	onInsightPress?: () => void;
	ctaLabel?: string;
	onCtaPress?: () => void;
};

export const CardAction = ({
	insightText,
	animateInsight,
	onInsightPress,
	ctaLabel,
	onCtaPress,
}: CardActionProps) => {
	if (!(insightText || ctaLabel)) {
		return null;
	}

	return (
		<Box flex={1} gap={12}>
			{insightText && (
				<InsightCallout
					text={insightText}
					animated={animateInsight}
					onPress={onInsightPress}
				/>
			)}

			{ctaLabel && onCtaPress && (
				<Box paddingHorizontal={SPACING.card} paddingBottom={8}>
					<Button mode="text" onPress={onCtaPress}>
						{ctaLabel}
					</Button>
				</Box>
			)}
		</Box>
	);
};
